	export enum EndOfDayStatusEnum {
		Open = 1,
		Completed = 2
	}
